module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "modal-show",
      rawName: "v-modal-show",
      value: (_vm.display),
      expression: "display"
    }]
  }, [_c('div', {
    staticClass: "mask",
    on: {
      "click": function($event) {
        return _vm.closeModal()
      }
    }
  }), _vm._v(" "), _c('section', {
    staticClass: "M_wrap M_notice M_style M_btn_0 M_style_2 M_style_2_h"
  }, [_c('div', {
    staticClass: "M_cont"
  }, [_c('p', {
    staticClass: "M_title T_18_25 T_b"
  }, [_c('span', [_vm._v(_vm._s(_vm.msgTitle))])]), _vm._v(" "), _c('div', {
    staticClass: "T_12_16 T_b",
    domProps: {
      "innerHTML": _vm._s(_vm.msgContent)
    }
  })]), _vm._v(" "), _c('a', {
    staticClass: "M_close I_n",
    on: {
      "click": function($event) {
        return _vm.closeModal()
      }
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-587dd4e2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/v2/components/common/RealNameCouponModal.vue
// module id = 510
// module chunks = 142